/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {InjuryClassification} from "../model/injury-classification";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class InjuryClassificationService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = inject(APP_CONFIG).baseUrl + '/api/injuryclassifications';
  }


  getAll(): Observable<InjuryClassification[]> {
    const url = `${this.baseUrl}/all`;
    return this.http.get(url, httpOptions).pipe(
      map(injuryClassification => injuryClassification as InjuryClassification[]));
  }

  updateInjuryClassificationById(injuryClassification: InjuryClassification): Observable<InjuryClassification>{
    const id = injuryClassification.injuryClassificationId;
    const url = `${this.baseUrl}/${id}`;

    return this.http.put(url,injuryClassification,httpOptions).pipe(
      map(injuryClassification => injuryClassification as InjuryClassification));
  }

  addInjuryClassification(injuryClassification: InjuryClassification): Observable<InjuryClassification>{
    const url = `${this.baseUrl}`;

    return this.http.post(url,injuryClassification,httpOptions).pipe(
      map(injuryClassification => injuryClassification as InjuryClassification));
  }
}
